/**
 * Видимость тематических разделов «Аналитики» (US-09 FR-1).
 *
 * module_id должны совпадать с реестром `super_admin_modules` на бэке —
 * раздел, выключенный супер-админом, исчезает из чипов страницы и из
 * сводной витрины «Все». Незарегистрированный на бэке раздел виден
 * по умолчанию (default-visible, как в useModulePresent).
 */
import { useContext } from 'react';

import type { AnalyticsFilter } from './analytics.page';
import { ModulesContext } from '../../contexts/ModulesContext';

export const ANALYTICS_SECTION_MODULE: Record<
  Exclude<AnalyticsFilter, 'all'>,
  string
> = {
  population: 'analytics.population',
  economy: 'analytics.economy',
  social: 'analytics.social',
  agriculture: 'analytics.agriculture',
  landFund: 'analytics.land-fund',
  infrastructure: 'analytics.infrastructure',
  construction: 'analytics.construction',
  snpNeeds: 'analytics.snp-needs',
};

/**
 * Предикат «раздел не выключен супер-админом». «all» всегда виден —
 * это дефолт страницы и точка возврата для скрытых разделов.
 */
export const useAnalyticsSectionPresent = (): ((
  filter: AnalyticsFilter,
) => boolean) => {
  const ctx = useContext(ModulesContext);
  return (filter) => {
    if (filter === 'all') return true;
    const entry = ctx?.modules.get(ANALYTICS_SECTION_MODULE[filter]);
    return entry === undefined ? true : entry.enabled;
  };
};
